import BootstrapStimulusController from "./bootstrap_stimulus_controller.js";

export default class extends BootstrapStimulusController {
  static targets = ["searchList", "searchType"];

  static values = {
    param: String,
    url: String,
  };

  // this must be done if you want to inherit from BootstrapStimulusController and have `connect` hook
  connect() {
    super.connect();
  }

  setType() {
    this.changeParam(this.searchListTarget, this.paramValue, this.searchTypeTarget.value);
  }

  // if it is multiple selectable we need to get all the options and change the
  // query
  setMultipleOptions() {
    const values = $.map($(this.searchTypeTarget).find(":selected"), (value) => value.text);
    this.changeParam(this.searchListTarget, this.paramValue, values);
  }

  // sometimes we change the parameter in URL
  setURL() {
    const values = this.searchTypeTarget.value;
    this.changeUrl(this.searchListTarget, this.urlValue, this.paramValue, values);
  }

  changeUrl(element, url_template, param, value) {
    const url = new URL(url_template.replace(param, value), window.location);
    element.dataset.url = url.toString();
  }

  changeParam(element, param, value) {
    const url = new URL(element.dataset.url, window.location);
    url.searchParams.set(param, value);
    element.dataset.url = url.toString();
  }
}
